import { FileItem, FileStatus } from '@sib/types';

export enum FileUploadPhase {
  Processing = 'processing',
  Waiting = 'waiting',
  Uploading = 'uploading',
  Complete = 'complete',
}

const FILE_UPLOAD_PHASE_SORT_RANK: Record<FileUploadPhase, number> = {
  [FileUploadPhase.Uploading]: 1,
  [FileUploadPhase.Processing]: 2,
  [FileUploadPhase.Waiting]: 3,
  [FileUploadPhase.Complete]: 4,
};

export const resolveFileUploadPhase = (
  fileItem: FileItem
): FileUploadPhase | null => {
  if (fileItem.status !== FileStatus.Uploading) return null;

  if (fileItem.progress >= 100) return FileUploadPhase.Complete;

  if (fileItem.progress > 0) return FileUploadPhase.Uploading;

  if (fileItem.md5Hash) return FileUploadPhase.Waiting;

  return FileUploadPhase.Processing;
};

export const getFileUploadSortRank = (fileItem: FileItem): number => {
  if (fileItem.status === FileStatus.Error) return 0;

  const phase = resolveFileUploadPhase(fileItem);
  if (phase != null) return FILE_UPLOAD_PHASE_SORT_RANK[phase];

  if (fileItem.status === FileStatus.Pending) return 5;

  if (fileItem.status === FileStatus.Uploaded) return 6;

  return 7;
};

export const compareFileUploadItems = (
  a: FileItem,
  b: FileItem,
  nameSortOrder: 'asc' | 'desc' = 'asc'
): number => {
  const rankDiff = getFileUploadSortRank(a) - getFileUploadSortRank(b);
  if (rankDiff !== 0) return rankDiff;

  const keyA = a.file.name.toLowerCase();
  const keyB = b.file.name.toLowerCase();
  const nameComparison = keyA > keyB ? 1 : keyA < keyB ? -1 : 0;

  return nameComparison * (nameSortOrder === 'asc' ? 1 : -1);
};
